import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { InstallationHttpClient, ParametreForAktuelleInstallation, UmbracoHttpClient } from "@e-forsyning/common/http";

import { Forbrug } from "../model/forbrug.model";
import { SammenlignForbrugIndstillinger } from "../model/sammenlign-forbrug-indstillinger.model";

@Injectable({ providedIn: "root" })
export class SammenlignForbrugRepository {
    constructor(private readonly umbracoHttp: UmbracoHttpClient, private readonly installationHttp: InstallationHttpClient) {}

    public hentForbrug(fofScript: string): Observable<Forbrug> {
        return this.installationHttp.postWithStringResult("api/getnormtal", fofScript, ParametreForAktuelleInstallation.true).pipe(
            map((data) => JSON.parse(data)),
            map((data) => ({
                normtal: Number(data.Normtal.toString().replace(",", ".")),
                realiseret: Number(data.Realiseret.toString().replace(",", ".")),
                enhed: data.Enhed
            }))
        );
    }

    public hentIndstillinger(): Observable<SammenlignForbrugIndstillinger> {
        return this.umbracoHttp.hentSideData<SammenlignForbrugIndstillinger>("sammenlign-forbrug");
    }
}
